export function formatGbp(value: number | undefined): string {
  return `£${(value ?? 0).toFixed(2)}`;
}
